import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { WagmiProvider } from "wagmi";
import "@/index.css";
import App from "@/App";
// Importing wallet.js runs createAppKit() at module scope, which registers
// the unified EVM + Solana + Bitcoin Reown modal globally.
import { wagmiConfig } from "@/lib/wallet";
import { SuiProvider } from "@/lib/SuiProviders";
import { TronProvider } from "@/lib/TronProviders";
import { BitcoinProvider } from "@/lib/BitcoinProviders";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: { staleTime: 60_000, refetchOnWindowFocus: false },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <WagmiProvider config={wagmiConfig}>
    <QueryClientProvider client={queryClient}>
      <SuiProvider>
        <TronProvider>
          <BitcoinProvider>
            <App />
          </BitcoinProvider>
        </TronProvider>
      </SuiProvider>
    </QueryClientProvider>
  </WagmiProvider>
);
